module.exports = __webpack_public_path__ + "static/media/kiki-back.4161ec13.jpeg";